import React from 'react'

import { LntButton } from '@app/components/base'

import { BUTTON_TYPE, SIZE } from '@app/constants'

import styles from './styles.module.scss'

import type { ErrorModalFooterProps } from './types'

export const ErrorModalFooter: React.FC<ErrorModalFooterProps> = ({ children, onClose }) => {
  return (
    <div className={ styles.errorModalFooter }>
      { children }
      <LntButton
        type={ BUTTON_TYPE.primary }
        size={ SIZE.middle }
        onClick={ onClose }
      >
        OK
      </LntButton>
    </div>
  )
}
